import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
import { computed } from 'vue';
import { NAV_CHANNEL_ICONS } from '@/constants/navChannelIcons.js';

/** 透明底素材：不用 screen 抠黑底 */

export default {
  __name: 'NavChannelIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator: value => Object.prototype.hasOwnProperty.call(NAV_CHANNEL_ICONS, value)
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const TRANSPARENT_ICONS = new Set(['apple', 'iphone']);
    const props = __props;
    const iconSrc = computed(() => NAV_CHANNEL_ICONS[props.name]);
    const transparent = computed(() => TRANSPARENT_ICONS.has(props.name));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("img", {
        class: _normalizeClass(["nav-channel-icon", {
          'is-active': __props.active,
          'is-transparent': transparent.value
        }]),
        src: iconSrc.value,
        alt: "",
        "aria-hidden": "true",
        draggable: "false"
      }, null, 10, _hoisted_1);
    };
  }
};